import { useEffect, useState } from "react";
import {
    APP_VERSION_STORAGE_KEY,
    fetchLatestAppVersion,
    getStoredAppVersion,
    setStoredAppVersion,
} from "../lib/appVersion";

export default function AppVersionBadge({ className = "" }) {
    const [version, setVersion] = useState(getStoredAppVersion());

    useEffect(() => {
        let isMounted = true;

        async function syncVersion() {
            try {
                const latestVersion = await fetchLatestAppVersion();
                if (!latestVersion || !isMounted) {
                    return;
                }

                setStoredAppVersion(latestVersion);
                setVersion(latestVersion);
            } catch {
                if (isMounted) {
                    setVersion(getStoredAppVersion());
                }
            }
        }

        syncVersion();

        const handleStorage = (event) => {
            if (event.key === APP_VERSION_STORAGE_KEY) {
                setVersion(event.newValue || "");
            }
        };

        window.addEventListener("storage", handleStorage);

        return () => {
            isMounted = false;
            window.removeEventListener("storage", handleStorage);
        };
    }, []);

    if (!version) {
        return null;
    }

    return (
        <span data-testid="app-version-badge" className={className}>
            {version}
        </span>
    );
}
